import React, {useEffect, useState} from 'react';

import { Draggable, Droppable } from 'components';


export const DragDrop = props => {
    const {
        // Droppable
        id,
        accept,
        direction,
        secondaryIndex,
        secDropStatus,
        secDropIDs,
        backgroundColor,
        onHoverHandler,
        onDropHandler,
        isDragged,
        hoverStyle,
        shouldAnimate,
        animation,
        margin,
        width,

        // Draggable
        index,
        onStartDragHandler,
        onEndDragHandler
    } = props;
    
    // console.log('DragDrop', {id: id, animation: animation})
    return (
        <Droppable {...props}>
            <Draggable {...props}>
                {props.children}
            </Draggable>
        </Droppable>
    )
    // return (<div>{props.children}</div>)
}

export default DragDrop